/* eslint-disable no-param-reassign */
import React, { useState, useContext, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import Section from 'modules/common/components/Section';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import uuid from 'react-uuid';
import { customStyle, reactSelectCustomStyleCms, ucwords } from 'helper';
import CmsContext from 'context/CmsContext';
import { get } from 'session';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import * as c from '../../constant';
import * as actions from '../../actions';
import UpdateLocation from './UpdateLocation';
// import BusinessActivityList from '../../components/BusinessActivityList';
import PreviousLocation from './PreviousLocation';
import Citizenship from '../../components/Citizenship';
import Activities from './components/Activities';
import BusinessLine from '../../../../../common/components/BusinessLine';

const RULES = {
  kind_of_ownership: 'required',
  owners_gender: 'required',
  business_name: 'required',
  tin_no: 'tin_no',
  dti_no:
    'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|min_5_char|max_20_char',
  sec_no:
    'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|min_5_char|max_20_char',
  cda_no: 'required_if:kind_of_ownership=COOPERATIVE|min_5_char|max_20_char',
  cellphone_no: 'required|cellphone_number',
  telephone_no: 'tel_number',
  email_address: 'required|email',
  municipality_code: 'required',
  barangay_code: 'required',
  // street: 'required',
  zip_code: 'required|number',
  incharge_first_name: 'required',
  incharge_last_name: 'required',
  nationality: 'required',
  // 'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
  area: 'required|number',
  // base_line: 'required|number',
  no_of_male_employees: 'required|number',
  no_of_female_employees: 'required|number',
  // no_of_employees: 'required|number',
  no_of_employees_residing_manila: 'required|number',
  no_of_van: 'required|number',
  no_of_truck: 'required|number',
  no_of_motorcycle: 'required|number',
  location_owned: 'required',
  lessor_name: 'required_if:location_owned=0',
  monthly_rental: 'required_if:location_owned=0',
  with_tax_incentives: 'required',
  tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
  activity_type: 'required',
  main_office_region_code: 'required',
  main_office_province_code: 'required',
  main_office_municipality_code: 'required',
  main_office_barangay_code: 'required',
  main_office_zip_code: 'required|number',
  tdn_no: 'required_if:is_tdn_selected=1|min_5_char|max_20_char',
  pin_no: 'required_if:is_pin_selected=1|min_5_char|max_20_char',
};

function ChangeRequestModal({
  changeApplication,
  id,
  history,
  getItem,
  getRegionsList,
  regionsList,
  getProvinceList,
  provinceList,
  getMunicipalityList,
  municipalityList,
  getBarangayList,
  barangayList,
  updating,
  updateList,
  getVetRegistrationList,
  closeModal,
  getBusinessNecessaryField,
  businessNecessaryField,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(c.INIT_FORM_STATE);
  const formDataDetails = _.get(formData, 'details', {});
  const formDataExistingActivities = _.get(formData, 'existing_activities', []);
  const formDataActivities = _.get(formData, 'activities', []);
  const ownership = _.get(formData, 'kind_of_ownership');
  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');
  const defaultSec = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_SEC_NO');
  const maskSec = _.get(CMS_MASKINGS, 'BPLS_E2E_SEC_NO');
  const defaultDti = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_DTI_NO');
  const maskDti = _.get(CMS_MASKINGS, 'BPLS_E2E_DTI_NO');
  const defaultCda = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_CDA_NO');
  const maskCda = _.get(CMS_MASKINGS, 'BPLS_E2E_CDA_NO');
  const defaultMasking = '********************';
  const defaultMaskPlaceHolder = '99999999999999999999';
  const formIsPinSelected = _.get(formData, 'is_pin_selected');
  const formIsTdnSelected = _.get(formData, 'is_tdn_selected');
  const bplsPin19DigitRegex = _.get(
      CMS_MASKINGS,
      'BPLS_E2E_PIN_19_DIGIT_REGEX'
    );
  const bplsPin19Digit = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_19_DIGIT');
  const bplsPinRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_REGEX');
  const bplsPin = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN');
  const defaultPin19Digit = _.get(
    CMS_MASKINGS,
    'DEFAULT_BPLS_E2E_PIN_19_DIGIT'
  );
  const defaultPin = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_PIN');
  const bplsTdnRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN_REGEX');
  const bplsTdn = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN');
  const defaultTdn = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_TDN');

  const businessPrevious = _.get(
    updateList,
    'included.bplsBusiness.attributes'
  );
  const businessChangeRequest = _.get(
    updateList,
    'included.bplsChangeRequests.attributes'
  );
  const detailsPrevious = _.get(businessPrevious, 'details', {});
  const newActivitiesPrev = _.get(businessPrevious, 'activities', []);
  const existingActivitiesPrev = _.get(businessPrevious, 'existing_activities', []);
  const requiredFields = Object.keys(detailsPrevious).reduce((acc, key) => {
    acc[key] = 'required';
    return acc;
  }, {});
  const previousDetailsQuantityMatrix = Object.values(detailsPrevious?.quantity_matrix ?? {})
    .flatMap(item => _.isArray(item) ? item : [])
    .reduce((acc, { multiplier, value }) => {
      if (multiplier && !_.isNaN(value)) {
        acc[multiplier] = +value;
      }
      return acc;
    }, {});
  
  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = businessNecessaryField.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const businessNecessaryValidator = useFormValidator(
    formDataDetails,
    requiredFields
  );

  const validateForm = useFormValidator(formData, RULES);

  useEffect(() => {
    const defaultPinMask = defaultPin
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPinRegex}~${bplsPin}`;
    const defaultPin19DigitMask = defaultPin19Digit
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPin19DigitRegex}~${bplsPin19Digit}`;

    if (!formIsPinSelected && defaultPin && defaultPin19Digit) return;

    validateForm.onSetObjectRules({
      ...RULES,
      pin_no: _.get(formData, 'pin_format')
        ? defaultPin19DigitMask
        : defaultPinMask,
    });
  }, [formIsPinSelected, _.get(formData, 'pin_format')]);

  useEffect(() => {
    if (formIsTdnSelected && !defaultTdn) {
      validateForm.onSetObjectRules({
        ...RULES,
        tdn_no: `required_if:tdn_selected=1|mask:${bplsTdnRegex}~${bplsTdn}`,
      });
    }
  }, [formIsTdnSelected]);

  useEffect(() => {
    const applicationStatusId = get('applicationStatusId');
    if (applicationStatusId) {
      getBusinessNecessaryField({
        application_status_id: get('applicationStatusId'),
      });
    }

    getRegionsList();
    getVetRegistrationList();
    getProvinceList({
      region_code: _.get(businessPrevious, 'main_office_region_code'),
    });
    getMunicipalityList({
      region_code: _.get(businessPrevious, 'main_office_region_code'),
      province_code: _.get(businessPrevious, 'main_office_province_code'),
    });
    getBarangayList({
      region_code: _.get(businessPrevious, 'main_office_region_code'),
      province_code: _.get(businessPrevious, 'main_office_province_code'),
      municipality_code: _.get(
        businessPrevious,
        'main_office_municipality_code'
      ),
      display_all: 1,
    });
  }, []);

  useEffect(() => {
    validateForm.validate();
    businessNecessaryValidator.validate();
  }, [JSON.stringify(formData)]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (
      _.get(formData, 'trade_name') === '' ||
      _.get(formData, 'incharge_middle_name') === '' ||
      _.get(formData, 'incharge_suffix_name') === '' ||
      _.get(formData, 'owners_gender') === ''
    ) {
      Object.keys(formData).forEach((key) => {
        if (
          formData[key] === undefined ||
          formData[key] === null ||
          formData[key] === false ||
          formData[key] === '[]'
        ) {
          delete formData[key];
        }
      });
    } else {
      Object.keys(formData).forEach((key) => {
        if (
          formData[key] === '' ||
          formData[key] === undefined ||
          formData[key] === null ||
          formData[key] === false ||
          formData[key] === '[]'
        ) {
          delete formData[key];
        }
      });
    }

    const res = (formDataActivities || []).map((x) => ({
      ...x,
      details: x.details && {
        ...x.details,
        ..._.mapValues(
          _.omit(x.details, 'quantity_matrix'),
          (val) => (val ?? '').toString().replace(/,/g, '')
        )
      }
    }));

    const existing_res = (formDataExistingActivities || []).map((x) => ({
      ...x,
      details: x.details && {
        ...x.details,
        ..._.mapValues(
          _.omit(x.details, 'quantity_matrix'),
          (val) => (val ?? '').toString().replace(/,/g, '')
        )
      }
    }));

    const { activities, existing_activities, ...others } = formData;

    const args = {
      ...others,
      ...(!isEmpty(res) && { activities: res }),
      ...(!isEmpty(existing_res) && { existing_activities: existing_res }),
    };

    return changeApplication(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);

      return history.push(`/bpls/applications/change/${id}`);
    });
  };

  useEffect(() => {
    if (businessChangeRequest || !isEmpty(businessChangeRequest)) {
      const changeRequestPin = _.get(businessChangeRequest, 'pin_no', '');
      // const pinFormatRegex19Digit = new RegExp(
      //   /^\d{3,3}-\d{2,2}-\d{3,3}-\d{3,3}-\d{3,3}-[\w\d]{5,5}$/
      // );
      const changeRequestTdn = _.get(businessChangeRequest, 'tdn_no', '');
      const necessaryDetails = _.get(businessChangeRequest, 'details', {});
      const { quantity_matrix, ...businessDetail } = necessaryDetails;
      const multiplierQuantityMatrix = Object.values(quantity_matrix ?? {})
        .flatMap(item => _.isArray(item) ? item : [])
        .reduce((acc, { multiplier, value }) => {
          if (multiplier && !Number.isNaN(value)) {
            acc[multiplier] = +value;
          }
          return acc;
        }, {});

      const combinedDetails = {
        ...businessDetail,
        quantity_matrix: multiplierQuantityMatrix,
      };

      const businessActivityChangeRequest = _.get(businessChangeRequest, 'existing_activities', []);
      const quantityMatrix = businessActivityChangeRequest.map(activity => ({
        ...activity,
        details: {
          ...activity.details,
          quantity_matrix: Object.values(activity.details.quantity_matrix || {})
            .flat()
            .reduce((acc, { multiplier, value }) => (
              { 
                ...acc, 
                [multiplier]: value 
              }
            ), {}
          )
        }
      }));

      setFormData((prev) => ({
        ...prev,
        ...businessChangeRequest,
        is_tdn_selected: changeRequestPin || !changeRequestTdn ? 0 : 1,
        is_pin_selected: changeRequestPin ? 1 : 0,
        details: combinedDetails,
        existing_activities: quantityMatrix
      }));

      // setIsPin(Boolean(changeRequestPin));
      // setIsFormatted(bplsPin19DigitRegex.test(changeRequestPin));
    }
  }, [JSON.stringify(businessChangeRequest)]);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
        zip: _.get(data, 'attributes.zip_code', ''),
      });
    });
    return newList;
  };

  const handleMainOfficeRegionSelect = (e) => {
    setFormData({
      ...formData,
      main_office_region_code: e.value,
      main_office_region_name: e.label,
      main_office_province_code: '',
      main_office_province_name: '',
      main_office_municipality_code: '',
      main_office_municipality_name: '',
      main_office_barangay_code: '',
      main_office_barangay_name: '',
      main_office_zip_code: '',
    });
    getProvinceList({ region_code: e.value });
  };

  const handleMainOfficeProvinceSelect = (e) => {
    setFormData({
      ...formData,
      main_office_province_code: e.value,
      main_office_province_name: e.label,
      main_office_municipality_code: '',
      main_office_municipality_name: '',
      main_office_barangay_code: '',
      main_office_barangay_name: '',
      main_office_zip_code: '',
    });
    getMunicipalityList({
      region_code: _.get(formData, 'main_office_region_code'),
      province_code: e.value,
    });
  };

  const handleMainOfficeMunicipalitySelect = (e) => {
    setFormData({
      ...formData,
      main_office_municipality_code: e.value,
      main_office_municipality_name: e.label,
      main_office_barangay_code: '',
      main_office_barangay_name: '',
      main_office_zip_code: '',
    });
    getBarangayList({
      region_code: _.get(formData, 'main_office_region_code'),
      province_code: _.get(formData, 'main_office_province_code'),
      municipality_code: e.value,
      display_all: 1,
    });
  };

  const handleMainOfficeBarangaySelect = (e) => {
    setFormData({
      ...formData,
      main_office_barangay_code: e.value,
      main_office_barangay_name: e.label,
      main_office_zip_code: e.zip,
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeSelectKind = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
      cda_no: '',
      sec_no: '',
      dti_no: '',
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [key]: e ? e.value : '',
      ...(key === 'location_owned' && {
        lessor_name: '',
        monthly_rental: '',
        tdn_no: '',
        pin_no: '',
        is_pin_selected: e.value,
        is_tdn_selected: e.value,
      }),
    }));
  };

  const onChangeBusinessNecessaryField = (key) => (e) => {
    const target = _.get(e, 'target');
    setFormData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [key]: target ? target.value : e.value,
      },
    }));
  };

  const selectOptions = (list) => {
    const newList = [];

    if (isEmpty(list)) return false;

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const getTitle = () => {
    switch (ownership) {
      case 'PARTNERSHIP':
      case 'CORPORATION':
      case 'COOPERATIVE':
        return 'President/Officer-in-charge Information';
      default:
        return 'Owner Information';
    }
  };

  const getAddressSelectValue = (key) => {
    const listMap = {
      main_office_region_code: regionsList,
      main_office_province_code: provinceList,
      main_office_municipality_code: municipalityList,
      main_office_barangay_code: barangayList,
    };

    const list = listMap[key];
    if (!list) return null;

    const code = _.get(formData, key);
    const selectItem = list.find((i) => _.get(i, 'attributes.code') === code);

    return selectItem
      ? {
          label: _.get(selectItem, 'attributes.name'),
          value: _.get(selectItem, 'attributes.code'),
        }
      : null;
  };

  const getPreviousAddress = (key) => {
    switch (key) {
      case 'main_office_region_code':
        return {
          label: _.get(businessPrevious, 'main_office_region_name'),
          value: _.get(businessPrevious, 'main_office_region_code'),
        };
      case 'main_office_province_code':
        return {
          label: _.get(businessPrevious, 'main_office_province_name'),
          value: _.get(businessPrevious, 'main_office_province_code'),
        };
      case 'main_office_municipality_code':
        return {
          label: _.get(businessPrevious, 'main_office_municipality_name'),
          value: _.get(businessPrevious, 'main_office_municipality_code'),
        };
      case 'main_office_barangay_code':
        return {
          label: _.get(businessPrevious, 'main_office_barangay_name'),
          value: _.get(businessPrevious, 'main_office_barangay_code'),
        };
      default:
        return null;
    }
  };

  const onChangeExistingActivities = (businessLineId, multiplier, key, value) => {
    setFormData((prev) => {
      const activities = _.cloneDeep(prev.existing_activities);
      const activity = activities.find(
        (item) => item?.business_line_id === businessLineId
      );

      if (!activity) return prev;

      if (key === 'business_line_id' || key === 'capital_amount') {
        activity[key] = value;
      } else {

        if (multiplier === 'multiplier') activity.details[key] = value;

        if (multiplier === 'quantity_matrix') activity.details.quantity_matrix[key] = value;

        // Update gross_amount if needed
        const grossFields = Object.entries(activity.details)
          .filter(([k]) => k.includes('gross_amount_') && k !== 'gross_amount')
          .reduce((sum, [, val]) => sum + (Number(val) || 0), 0);

        if (grossFields > 0) activity.details.gross_amount = grossFields;
      }

      return { ...prev, existing_activities: activities };
    });
  };

  const onChangeActivities = (businessLineId, multiplier, key, value) => {
    setFormData((prev) => {
      const activities = _.cloneDeep(prev.activities);
      const activity = activities.find(
        (item) => item?.business_line_id === businessLineId
      );

      if (!activity) return prev;

      if (key === 'business_line_id' || key === 'capital_amount') {
        activity[key] = value;
      } else {

        if (multiplier === 'multiplier') activity.details[key] = value;

        if (multiplier === 'quantity_matrix') activity.details.quantity_matrix[key] = value;

        // Update gross_amount if needed
        const grossFields = Object.entries(activity.details)
          .filter(([k]) => k.includes('gross_amount_') && k !== 'gross_amount')
          .reduce((sum, [, val]) => sum + (Number(val) || 0), 0);

        if (grossFields > 0) activity.details.gross_amount = grossFields;
      }

      return { ...prev, activities };
    });
  };

  const renderInputMaskConfigFromCms = (isPinSelected, pinFormat) => {
    if (isPinSelected && pinFormat) {
      return !defaultPin19Digit ? bplsPin19Digit : '';
    }

    if (isPinSelected && !pinFormat) {
      return !defaultPin ? bplsPin : '';
    }

    if (!isPinSelected && !pinFormat) {
      return !defaultTdn ? bplsTdn : '';
    }

    return '';
  };

  const handlePinFormat = (e) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        pin_format: 1,
      });
    }

    if (!e.target.checked) {
      setFormData({
        ...formData,
        pin_no: _.get(formData, 'pin_no')?.replace(
          `/${_.get(CMS_MASKINGS, 'BPLS_E2E_DTI_NO_REGEX')}/`,
          '$1-$2-$3-$4-$5'
        ), // format pin_no into (000-00-000-000-000) // todo: add this to masking/cms for dynamic handling of pinformat
        pin_format: 0,
      });
    }
  };

  const onChangeCheckbox = (e) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        tdn_no: '',
        is_pin_selected: 1,
        is_tdn_selected: 0,
      });
    }

    if (!e.target.checked) {
      setFormData({
        ...formData,
        pin_no: '',
        is_pin_selected: 0,
        is_tdn_selected: 1,
        pin_format: 0,
      });
    }
  };

  const dtiNo = _.get(formData, 'dti_no', '');
  const secNo = _.get(formData, 'sec_no', '');
  const cdaNo = _.get(formData, 'cda_no', '');

  const dtiField = (
    <div className="col-12 form-group">
      <label htmlFor="dti_no" className="form-label mb-0">
        DTI Registration No.
        {validateForm.renderMessage('dti_no')}
      </label>
      <InputMask
        className="form-control text-uppercase"
        placeholder={
          defaultDti ? defaultMaskPlaceHolder : maskDti.toUpperCase()
        }
        mask={defaultDti ? defaultMasking : maskDti}
        type="text"
        name="dti_no"
        onChange={onChange}
        value={dtiNo}
        maskChar=""
      />
    </div>
  );

  const secField = (
    <div className="col-12 form-group">
      <label htmlFor="sec_no" className="form-label mb-0">
        SEC Registration No.
        {validateForm.renderMessage('sec_no')}
      </label>
      <InputMask
        className="form-control text-uppercase"
        placeholder={
          defaultSec ? defaultMaskPlaceHolder : maskSec.toUpperCase()
        }
        mask={defaultSec ? defaultMasking : maskSec}
        type="text"
        name="sec_no"
        onChange={onChange}
        value={secNo}
        maskChar=""
      />
    </div>
  );

  const cdaField = (
    <div className="col-12 form-group">
      <label htmlFor="cda_no" className="form-label mb-0">
        CDA Registration No.
        {validateForm.renderMessage('cda_no')}
      </label>
      <InputMask
        className="form-control text-uppercase"
        placeholder={
          defaultCda ? defaultMaskPlaceHolder : maskCda.toUpperCase()
        }
        mask={defaultCda ? defaultMasking : maskCda}
        type="text"
        name="cda_no"
        onChange={onChange}
        value={cdaNo}
        maskChar=""
      />
    </div>
  );

  const renderRegistrationNumber = () => {
    switch (ownership) {
      case 'SOLE PROPRIETORSHIP':
        return dtiField;

      case 'CORPORATION':
      case 'ONE PERSON CORPORATION':
      case 'PARTNERSHIP':
        return secField;

      case 'COOPERATIVE':
        return cdaField;

      default:
        if (dtiNo) return dtiField;
        if (secNo) return secField;
        if (cdaNo) return cdaField;
        return null;
    }
  };

  const onChangeDetails = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        quantity_matrix: {
          ...prev.details.quantity_matrix,
          [key]: value,
        }
      },
    }));
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <Section title="Business Information and Registration">
          <div className="row">
            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Current Information
              </div>
              <div className="row mt-2">
                {/* <div className="col-12 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Business Identification Number (BIN)
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="bin"
                    onChange={onChange}
                    value={_.get(businessPrevious, 'bin')}
                    disabled
                  />
                </div> */}

                {_.get(businessChangeRequest, 'business_name') && (
                  <div className="col-12 form-group">
                    <label htmlFor="business_name" className="form-label mb-0">
                      Business Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="business_name"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'business_name') || ''}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'trade_name') && (
                  <div className="col-12 form-group">
                    <label htmlFor="trade_name" className="form-label mb-0">
                      Trade Name / Franchise (If Applicable) :
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="trade_name"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'trade_name') || ''}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'kind_of_ownership') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="kind_of_ownership"
                      className="form-label mb-0"
                    >
                      Business Type
                    </label>
                    <Select
                      name="kind_of_ownership"
                      placeholder="Select Business Type"
                      onChange={handleOnChangeSelect('kind_of_ownership')}
                      options={c.KIND_OF_OWNERSHIP}
                      value={
                        c.KIND_OF_OWNERSHIP.find(
                          (item) =>
                            _.get(businessPrevious, 'kind_of_ownership') ===
                            _.get(item, 'value')
                        ) || ''
                      }
                      isDisabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'dti_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="dti_no" className="form-label mb-0">
                      DTI Registration No.
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="dti_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'dti_no', '')}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'sec_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="sec_no" className="form-label mb-0">
                      SEC Registration No.
                    </label>
                    <InputMask
                      className="form-control text-uppercase"
                      placeholder={
                        defaultSec
                          ? defaultMaskPlaceHolder
                          : maskSec.toUpperCase()
                      }
                      mask={defaultSec ? defaultMasking : maskSec}
                      type="text"
                      name="sec_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'sec_no', '')}
                      maskChar=""
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'cda_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="cda_no" className="form-label mb-0">
                      CDA Registration No.
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="cda_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'cda_no', '')}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'tin_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="tin_no" className="form-label mb-0">
                      Tax Identification Number (TIN)
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="tin_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'tin_no', '')}
                      disabled
                    />
                  </div>
                )}

                <p className="col-12 font-weight-bold">Contact Information</p>

                {_.get(businessChangeRequest, 'email_address') && (
                  <div className="col-12 form-group">
                    <label htmlFor="email_address" className="form-label mb-0">
                      Email Address
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email_address"
                      id="email_address"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'email_address') || ''}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'cellphone_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="cellphone_no" className="form-label mb-0">
                      Mobile Number
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="cellphone_no"
                      id="cellphone_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'cellphone_no') || ''}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'telephone_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="telephone_no" className="form-label mb-0">
                      Telephone Number
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="telephone_no"
                      id="telephone_no"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'telephone_no') || ''}
                      disabled
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Requested Changes
              </div>
              <div className="row mt-2">
                {/* <div className="col-12" style={{ padding: '39px' }} /> */}

                {_.get(businessChangeRequest, 'business_name') && (
                  <div className="col-12 form-group">
                    <label htmlFor="business_name" className="form-label mb-0">
                      Business Name:{' '}
                      {validateForm.renderMessage('business_name')}
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="business_name"
                      onChange={onChange}
                      value={_.get(formData, 'business_name') || ''}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'trade_name') && (
                  <div className="col-12 form-group">
                    <label htmlFor="trade_name" className="form-label mb-0">
                      Trade Name / Franchise (If Applicable)
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="trade_name"
                      onChange={onChange}
                      value={_.get(formData, 'trade_name') || ''}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'kind_of_ownership') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="kind_of_ownership"
                      className="form-label mb-0"
                    >
                      Business Type:{' '}
                      {validateForm.renderMessage('kind_of_ownership')}
                    </label>
                    <Select
                      name="kind_of_ownership"
                      placeholder="Select Business Type"
                      onChange={handleOnChangeSelectKind('kind_of_ownership')}
                      options={c.KIND_OF_OWNERSHIP}
                      value={
                        c.KIND_OF_OWNERSHIP.find(
                          (item) => ownership === _.get(item, 'value')
                        ) || ''
                      }
                    />
                  </div>
                )}

                {renderRegistrationNumber()}

                {_.get(businessChangeRequest, 'tin_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="tin_no" className="form-label mb-0">
                      Tax Identification Number (TIN)
                      {validateForm.renderMessage('tin_no')}
                    </label>
                    <InputMask
                      className="form-control text-uppercase"
                      placeholder={_.get(
                        CMS_MASKINGS,
                        'BPLS_E2E_TIN_NO',
                        ''
                      ).toUpperCase()}
                      mask={_.get(CMS_MASKINGS, 'BPLS_E2E_TIN_NO')}
                      type="text"
                      name="tin_no"
                      onChange={onChange}
                      value={_.get(formData, 'tin_no', '')}
                      maskChar=""
                    />
                  </div>
                )}

                <p className="col-12 font-weight-bold">Contact Information</p>

                {_.get(businessChangeRequest, 'email_address') && (
                  <div className="col-12 form-group">
                    <label htmlFor="email_address" className="form-label mb-0">
                      Email Address{' '}
                      {validateForm.renderMessage('email_address')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email_address"
                      id="email_address"
                      onChange={onChange}
                      value={_.get(formData, 'email_address') || ''}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'cellphone_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="cellphone_no" className="form-label mb-0">
                      Mobile Number {validateForm.renderMessage('cellphone_no')}
                    </label>
                    <InputMask
                      className="form-control"
                      placeholder="639999999999"
                      mask="639999999999"
                      type="text"
                      name="cellphone_no"
                      onChange={onChange}
                      value={_.get(formData, 'cellphone_no', '')}
                      maskChar=""
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'telephone_no') && (
                  <div className="col-12 form-group">
                    <label htmlFor="telephone_no" className="form-label mb-0">
                      Telephone Number{' '}
                      {validateForm.renderMessage('telephone_no')}
                    </label>
                    <InputMask
                      className="form-control"
                      placeholder="99-9999-9999"
                      mask="99-9999-9999"
                      type="text"
                      name="telephone_no"
                      onChange={onChange}
                      value={_.get(formData, 'telephone_no', '')}
                      maskChar=""
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section title={getTitle()}>
          <div className="row p-2">
            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Current Information
              </div>
              <div className="row p-2">
                {_.get(businessChangeRequest, 'incharge_first_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_first_name"
                      className="form-label mb-0"
                    >
                      First Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_first_name"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'incharge_first_name', '')}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_middle_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_middle_name"
                      className="form-label mb-0"
                    >
                      Middle Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_middle_name"
                      onChange={onChange}
                      value={_.get(
                        businessPrevious,
                        'incharge_middle_name',
                        ''
                      )}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_last_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_last_name"
                      className="form-label mb-0"
                    >
                      Last Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_last_name"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'incharge_last_name', '')}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_suffix_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_suffix_name"
                      className="form-label mb-0"
                    >
                      Extension Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_suffix_name"
                      onChange={onChange}
                      value={_.get(
                        businessPrevious,
                        'incharge_suffix_name',
                        ''
                      )}
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'owners_gender') && (
                  <div className="col-12 form-group">
                    <label htmlFor="owners_gender" className="form-label mb-0">
                      Sex
                    </label>
                    <Select
                      name="owners_gender"
                      placeholder="-Select-"
                      onChange={handleOnChangeSelect('owners_gender')}
                      options={c.OWNERS_GENDER}
                      value={
                        c.OWNERS_GENDER.find(
                          (item) =>
                            _.get(businessPrevious, 'owners_gender') ===
                            _.get(item, 'value')
                        ) || ''
                      }
                      isDisabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'nationality') && (
                  <div className="col-12 form-group">
                    <label htmlFor="nationality" className="form-label mb-0">
                      Country of Citizenship
                    </label>
                    <Citizenship
                      name="nationality"
                      onChange={onChange}
                      value={_.get(businessPrevious, 'nationality') || ''}
                      disabled
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Requested Changes
              </div>
              <div className="row p-2">
                {_.get(businessChangeRequest, 'incharge_first_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_first_name"
                      className="form-label mb-0"
                    >
                      First Name{' '}
                      {validateForm.renderMessage('incharge_first_name')}
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_first_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_first_name', '')}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_middle_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_middle_name"
                      className="form-label mb-0"
                    >
                      Middle Name
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_middle_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_middle_name', '')}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_last_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_last_name"
                      className="form-label mb-0"
                    >
                      Last Name{' '}
                      {validateForm.renderMessage('incharge_last_name')}
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="incharge_last_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_last_name', '')}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'incharge_suffix_name') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="incharge_suffix_name"
                      className="form-label mb-0"
                    >
                      Extension Name
                    </label>
                    <Select
                      name="incharge_suffix_name"
                      placeholder="-Select-"
                      onChange={handleOnChangeSelect('incharge_suffix_name')}
                      options={c.EXTENSION_NAMES}
                      value={
                        c.EXTENSION_NAMES.find(
                          (item) =>
                            _.get(formData, 'incharge_suffix_name') ===
                            _.get(item, 'value')
                        ) || ''
                      }
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'owners_gender') && (
                  <div className="col-12 form-group">
                    <label htmlFor="owners_gender" className="form-label mb-0">
                      Sex {validateForm.renderMessage('owners_gender')}
                    </label>
                    <Select
                      name="owners_gender"
                      placeholder="-Select-"
                      onChange={handleOnChangeSelect('owners_gender')}
                      options={c.OWNERS_GENDER}
                      value={
                        c.OWNERS_GENDER.find(
                          (item) =>
                            _.get(formData, 'owners_gender') ===
                            _.get(item, 'value')
                        ) || ''
                      }
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'nationality') && (
                  <div className="col-12 form-group">
                    <label htmlFor="nationality" className="form-label mb-0">
                      Country of Citizenship{' '}
                      {validateForm.renderMessage('nationality')}
                    </label>
                    <Citizenship
                      name="nationality"
                      onChange={onChange}
                      value={_.get(formData, 'nationality') || ''}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section title="Business Address">
          <div className="row p-2">
            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Current Information
              </div>
              <div className="row p-2">
                {_.get(businessChangeRequest, 'main_office_region_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">Region</label>
                    <div>
                      <Select
                        options={createDropdown(regionsList)}
                        styles={customStyle}
                        placeholder="Select Region"
                        value={getPreviousAddress('main_office_region_code')}
                        onChange={(e) => {
                          handleMainOfficeRegionSelect(e);
                        }}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(businessChangeRequest, 'main_office_province_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">Province</label>
                    <div>
                      <Select
                        options={createDropdown(provinceList)}
                        styles={customStyle}
                        placeholder="Select Province"
                        value={getPreviousAddress('main_office_province_code')}
                        onChange={(e) => {
                          handleMainOfficeProvinceSelect(e);
                        }}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(
                  businessChangeRequest,
                  'main_office_municipality_code'
                ) && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">City/Municipality</label>
                    <div>
                      <Select
                        options={createDropdown(municipalityList)}
                        styles={customStyle}
                        placeholder="Select City/Municipality"
                        value={getPreviousAddress(
                          'main_office_municipality_code'
                        )}
                        onChange={(e) => {
                          handleMainOfficeMunicipalitySelect(e);
                        }}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(businessChangeRequest, 'main_office_barangay_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">Barangay</label>
                    <div>
                      <Select
                        options={createDropdown(barangayList)}
                        styles={customStyle}
                        placeholder="Select Barangay"
                        value={getPreviousAddress('main_office_barangay_code')}
                        onChange={(e) => {
                          handleMainOfficeBarangaySelect(e);
                        }}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {/* {_.get(businessChangeRequest, 'main_office_barangay_code') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="main_office_zip_code"
                      className="form-label mb-0"
                    >
                      Zip Code
                    </label>
                    <InputMask
                      className="form-control"
                      placeholder="Enter Zip Code"
                      mask="9999"
                      type="text"
                      name="main_office_zip_code"
                      onChange={onChange}
                      value={
                        _.get(businessPrevious, 'main_office_zip_code') || ''
                      }
                      disabled
                    />
                  </div>
                )} */}

                {_.get(businessChangeRequest, 'main_office_street') && (
                  <div className="col-12 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Address Line 1
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="main_office_street"
                      onChange={onChange}
                      value={
                        _.get(businessPrevious, 'main_office_street') || ''
                      }
                      disabled
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'location_owned') !== null ? (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">Location Owned</label>
                    <div>
                      <Select
                        options={c.YES_NO}
                        styles={customStyle}
                        placeholder="-Select-"
                        value={c.YES_NO.find(
                          (i) =>
                            i.value ===
                            _.get(businessPrevious, 'location_owned')
                        )}
                        isDisabled
                        onChange={handleOnChangeSelect('location_owned')}
                      />
                    </div>
                  </div>
                ) : null}

                {_.get(businessPrevious, 'location_owned') ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor={
                        _.get(businessPrevious, 'tdn_no') ? 'tdn_no' : 'pin_no'
                      }
                      className="form-label mb-0"
                    >
                      {_.get(businessPrevious, 'tdn_no')
                        ? 'Tax Declaration No.'
                        : 'Property Identification No.'}
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name={
                        _.get(businessPrevious, 'tdn_no') ? 'tdn_no' : 'pin_no'
                      }
                      onChange={onChange}
                      value={
                        _.get(businessPrevious, 'tdn_no') ||
                        _.get(businessPrevious, 'pin_no') ||
                        ''
                      }
                      disabled
                    />
                  </div>
                ) : (
                  <>
                    <div className="col-12 form-group">
                      <label htmlFor="lessor_name" className="form-label mb-0">
                        Lessor Name
                      </label>
                      <input
                        className="form-control text-uppercase"
                        type="text"
                        name="lessor_name"
                        onChange={onChange}
                        value={_.get(businessPrevious, 'lessor_name')}
                        disabled
                      />
                    </div>

                    <div className="col-12 form-group">
                      <label
                        htmlFor="monthly_rental"
                        className="form-label mb-0"
                      >
                        Monthly Rental
                      </label>
                      <input
                        className="form-control text-uppercase"
                        type="number"
                        name="monthly_rental"
                        onChange={onChange}
                        value={_.get(businessPrevious, 'monthly_rental')}
                        disabled
                      />
                    </div>
                  </>
                )}

                {_.get(businessChangeRequest, 'pinned_geolocation') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="pinned_geolocation"
                      className="form-label mb-0"
                    >
                      Pinned Address{' '}
                    </label>
                    <PreviousLocation
                      pinLocation={
                        _.get(businessPrevious, 'pinned_geolocation') || ''
                      }
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Requested Changes
              </div>
              <div className="row p-2">
                {_.get(businessChangeRequest, 'main_office_region_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">
                      Region
                      {validateForm.renderMessage('main_office_region_code')}
                    </label>
                    <div>
                      <Select
                        options={createDropdown(regionsList)}
                        styles={customStyle}
                        placeholder="Select Region"
                        value={getAddressSelectValue('main_office_region_code')}
                        onChange={handleMainOfficeRegionSelect}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(businessChangeRequest, 'main_office_province_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">
                      Province
                      {validateForm.renderMessage('main_office_province_code')}
                    </label>
                    <div>
                      <Select
                        options={createDropdown(provinceList)}
                        styles={customStyle}
                        placeholder="Select Province"
                        value={getAddressSelectValue(
                          'main_office_province_code'
                        )}
                        onChange={handleMainOfficeProvinceSelect}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(
                  businessChangeRequest,
                  'main_office_municipality_code'
                ) && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">
                      City/Municipality
                      {validateForm.renderMessage(
                        'main_office_municipality_code'
                      )}
                    </label>
                    <div>
                      <Select
                        options={createDropdown(municipalityList)}
                        styles={customStyle}
                        placeholder="Select City/Municipality"
                        value={getAddressSelectValue(
                          'main_office_municipality_code'
                        )}
                        onChange={handleMainOfficeMunicipalitySelect}
                        isDisabled
                      />
                    </div>
                  </div>
                )}

                {_.get(businessChangeRequest, 'main_office_barangay_code') && (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">
                      Barangay
                      {validateForm.renderMessage('main_office_barangay_code')}
                    </label>
                    <div>
                      <Select
                        options={createDropdown(barangayList)}
                        styles={customStyle}
                        placeholder="Select Barangay"
                        value={getAddressSelectValue(
                          'main_office_barangay_code'
                        )}
                        onChange={(e) => {
                          handleMainOfficeBarangaySelect(e);
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* {_.get(businessChangeRequest, 'main_office_zip_code') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="main_office_zip_code"
                      className="form-label mb-0"
                    >
                      Zip Code
                      {validateForm.renderMessage('main_office_zip_code')}
                    </label>
                    <InputMask
                      className="form-control"
                      placeholder="Enter Zip Code"
                      mask="9999"
                      type="text"
                      name="main_office_zip_code"
                      onChange={onChange}
                      value={_.get(formData, 'main_office_zip_code') || ''}
                    />
                  </div>
                )} */}

                {_.get(businessChangeRequest, 'main_office_street') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="main_office_street"
                      className="form-label mb-0"
                    >
                      Address Line 1
                    </label>
                    <input
                      className="form-control text-uppercase"
                      type="text"
                      name="main_office_street"
                      onChange={onChange}
                      value={_.get(formData, 'main_office_street') || ''}
                    />
                  </div>
                )}

                {_.get(businessChangeRequest, 'location_owned') !== null ? (
                  <div className="col-12 form-group">
                    <label className="form-label mb-0">
                      Location Owned{' '}
                      {validateForm.renderMessage('location_owned')}
                    </label>
                    <div>
                      <Select
                        options={c.YES_NO}
                        styles={customStyle}
                        placeholder="-Select-"
                        value={c.YES_NO.find(
                          (i) => i.value === _.get(formData, 'location_owned')
                        )}
                        onChange={handleOnChangeSelect('location_owned')}
                      />
                    </div>
                  </div>
                ) : null}

                {(_.get(formData, 'location_owned') || formIsPinSelected || formIsTdnSelected) ? (
                  <div className="col-12 form-group d-flex align-items-center">
                    <div
                      className='d-flex align-items-center mr-2'
                    >
                      <input
                        className="mb-0"
                        name="pin"
                        id="pin"
                        type="checkbox"
                        checked={formIsPinSelected}
                        onChange={onChangeCheckbox}
                      />
                      <label
                        htmlFor="pin"
                        className="full-label my-0 py-0 ml-1"
                      >
                        PIN
                      </label>
                    </div>
                    {formIsPinSelected ? (
                      <div className="d-flex align-items-center">
                        <input
                          className="mb-0"
                          name="pinFormat"
                          id="pinFormat"
                          type="checkbox"
                          checked={_.get(formData, 'pin_format') ? 1 : 0}
                          onChange={handlePinFormat}
                        />
                        <label
                          htmlFor="pinFormat"
                          className="full-label my-0 py-0 ml-1"
                        >
                          19-Digit Format
                        </label>
                      </div>
                    ): ''}
                  </div>
                ) : null}

                {(_.get(formData, 'location_owned') || formIsPinSelected || formIsTdnSelected) ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor={!formIsPinSelected ? 'tdn_no' : 'pin_no'}
                      className="form-label mb-0"
                    >
                      {!formIsPinSelected
                        ? 'Tax Declaration No.'
                        : 'Property Identification No.'}{' '}
                      {formIsPinSelected !== 1
                        ? validateForm.renderMessage('tdn_no')
                        : validateForm.renderMessage('pin_no')}
                    </label>
                    <InputMask
                      className="form-control text-uppercase"
                      placeholder=''
                      mask={renderInputMaskConfigFromCms(
                        formIsPinSelected,
                        _.get(formData, 'pin_format')
                      )}
                      type="text"
                      name={!formIsPinSelected ? 'tdn_no' : 'pin_no'}
                      onChange={onChange}
                      value={
                        !formIsPinSelected
                          ? _.get(formData, 'tdn_no')
                          : _.get(formData, 'pin_no')
                      }
                      maskChar=""
                    />
                  </div>
                ) : (
                  <>
                    <div className="col-12 form-group">
                      <label htmlFor="lessor_name" className="form-label mb-0">
                        Lessor Name {validateForm.renderMessage('lessor_name')}
                      </label>
                      <input
                        className="form-control text-uppercase"
                        type="text"
                        name="lessor_name"
                        onChange={onChange}
                        value={_.get(formData, 'lessor_name') || ''}
                      />
                    </div>

                    <div className="col-12 form-group">
                      <label
                        htmlFor="monthly_rental"
                        className="form-label mb-0"
                      >
                        Monthly Rental{' '}
                        {validateForm.renderMessage('monthly_rental')}
                      </label>
                      {/* <input
                        className="form-control text-uppercase"
                        type="number"
                        name="monthly_rental"
                        onChange={onChange}
                        value={_.get(formData, 'monthly_rental') || ''}
                      /> */}
                      <NumberFormat
                        name="monthly_rental"
                        id="monthly_rental"
                        placeholder="0.00"
                        className="mt-1 form-control"
                        onValueChange={(values) => {
                          const { value } = values;
                          setFormData({
                            ...formData,
                            monthly_rental: value,
                          });
                        }}
                        displayType="input"
                        decimalScale={2}
                        isNumericString
                        allowNegative
                        thousandSeparator
                        allowLeadingZeros
                        prefix="₱ "
                        value={_.get(formData, 'monthly_rental')}
                        isAllowed={(values) => {
                          const { value } = values;
                          if (!value) return true;
                          const val = new Decimal(value);
                          const max = new Decimal(MAX_LIMIT);
                          return value === undefined || val.lte(max);
                        }}
                      />
                    </div>
                  </>
                )}

                {_.get(businessChangeRequest, 'pinned_geolocation') && (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="pinned_geolocation"
                      className="form-label mb-0"
                    >
                      Pinned Address{' '}
                      {validateForm.renderMessage('pinned_geolocation')}
                    </label>
                    <UpdateLocation
                      formData={formData}
                      setFormData={setFormData}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section title="Business Operations">
          <div className="row">
            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Current Information
              </div>
              <div className="row">
                {_.get(businessChangeRequest, 'area') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="area" className="form-label mb-0">
                      Business Area/Total Floor Area (sq.m)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="area"
                      value={_.get(businessPrevious, 'area') || ''}
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(
                  businessChangeRequest,
                  'no_of_employees_residing_manila'
                ) !== null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_employees_residing_manila"
                      className="form-label mb-0"
                    >
                      No. of Employees residing within Area
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_employees_residing_manila"
                      value={
                        _.get(
                          businessPrevious,
                          'no_of_employees_residing_manila'
                        ) || 0
                      }
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_male_employees') !==
                null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_male_employees"
                      className="form-label mb-0"
                    >
                      No. of Male Employees
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_male_employees"
                      value={
                        _.get(businessPrevious, 'no_of_male_employees') || 0
                      }
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_female_employees') !==
                null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      No. of Female Employees
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_female_employees"
                      value={
                        _.get(businessPrevious, 'no_of_female_employees') || 0
                      }
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_van') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="no_of_van" className="form-label mb-0">
                      No. of Van Delivery Vehicle: (0 if not applicable)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_van"
                      value={_.get(businessPrevious, 'no_of_van') || 0}
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_truck') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="no_of_truck" className="form-label mb-0">
                      No. of Truck Delivery Vehicle: (0 if not applicable)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_truck"
                      value={_.get(businessPrevious, 'no_of_truck') || 0}
                      disabled
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_motorcycle') !== null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_motorcycle"
                      className="form-label mb-0"
                    >
                      No. of Motorcycle Delivery Vehicle: (0 if not applicable)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="no_of_motorcycle"
                      value={_.get(businessPrevious, 'no_of_motorcycle') || 0}
                      disabled
                    />
                  </div>
                ) : null}

                {filteredBusinessNecessaryField.map((item) => {
                  const multiplier = _.get(item, 'multiplier', '');
                  const options = _.get(item, 'options');
                  return _.get(
                    businessChangeRequest,
                    `details.${multiplier}`
                  ) !== null ? (
                    <Fragment key={uuid()}>
                      {options ? (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className="col-12 form-group">
                          <label className="form-label mb-0">
                            {ucwords(multiplier ?? '').replace(/_/g, ' ')}
                          </label>
                          <Select
                            name={multiplier}
                            options={selectOptions(options)}
                            value={
                              selectOptions(options).find((option) => {
                                return (
                                  _.get(detailsPrevious, multiplier) ===
                                  _.get(option, 'value')
                                );
                              }) || ''
                            }
                            onChange={() => {}}
                            components={{ IndicatorSeparator: () => null }}
                            isDisabled
                          />
                        </div>
                      ) : (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className="col-12 form-group">
                          <label
                            htmlFor="last_name"
                            className="form-label mb-0"
                          >
                            {ucwords(multiplier ?? '').replace(/_/g, ' ')}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name={multiplier}
                            onChange={onChangeBusinessNecessaryField}
                            value={_.get(detailsPrevious, multiplier) || 0}
                            disabled
                          />
                        </div>
                      )}
                    </Fragment>
                  ) : (
                    <></>
                  );
                })}
                {!_.isEmpty(filteredQuantityMatrix) ? (
                  filteredQuantityMatrix.map((item) => {
                    const multiplier = _.get(item, 'multiplier', '');

                    return (
                      <React.Fragment>
                        <div className='form-group col-12 mb-0'>
                          <label className='form-label mb-0 text-capitalize'>
                            {multiplier}
                          </label>
                        </div>
                        <div className="w-100 border rounded-lg mx-3">
                          <table className="table table-borderless table-sm table-striped table-hover mb-0">
                            <thead>
                              <tr className="form-group">
                                <td className="col-4 form-label text-center border-right">Unit</td>
                                <td className="col-4 form-label text-center border-right">Capacity</td>
                                <td className="col-4 form-label text-center">Number of Units</td>
                              </tr>
                            </thead>
                            <tbody>
                              {item.quantity_matrix.map((quantityMatrixItem) => {
                                const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                                return (
                                  // eslint-disable-next-line react/no-array-index-key
                                  <tr
                                    key={quantityMatrixMultiplier}
                                    className="border-top form-group"
                                  >
                                    <td className="col-4 text-left form-label border-right">
                                      {_.get(quantityMatrixItem, 'unit')}
                                    </td>
                                    <td className="col-4 text-left form-label border-right">
                                      {_.get(quantityMatrixItem, 'capacity')}
                                    </td>
                                    <td className="col-4 text-left form-label">
                                      <NumberFormat
                                        name={quantityMatrixMultiplier}
                                        id={quantityMatrixMultiplier}
                                        allowLeadingZeros
                                        className="form-control"
                                        onValueChange={(values) => {
                                          const { floatValue } = values;
                                          onChangeDetails(quantityMatrixMultiplier, floatValue);
                                        }}
                                        displayType="input"
                                        thousandSeparator
                                        isNumericString
                                        prefix=""
                                        value={previousDetailsQuantityMatrix[quantityMatrixMultiplier]}
                                        placeholder="_"
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </React.Fragment>
                    )
                  })
                ) : (
                  ''
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                Requested Changes
              </div>
              <div className="row mt-2">
                {_.get(businessChangeRequest, 'area') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="area" className="form-label mb-0">
                      Business Area/Total Floor Area (sq.m){' '}
                      {validateForm.renderMessage('area')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="area"
                      onChange={onChange}
                      value={_.get(formData, 'area')}
                    />
                  </div>
                ) : null}

                {_.get(
                  businessChangeRequest,
                  'no_of_employees_residing_manila'
                ) !== null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_employees_residing_manila"
                      className="form-label mb-0"
                    >
                      No. of Employees residing within Area:{' '}
                      {validateForm.renderMessage(
                        'no_of_employees_residing_manila'
                      )}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_employees_residing_manila"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_employees_residing_manila')}
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_male_employees') !==
                null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_male_employees"
                      className="form-label mb-0"
                    >
                      No. of Male Employees:{' '}
                      {validateForm.renderMessage('no_of_male_employees')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_male_employees"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_male_employees')}
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_female_employees') !==
                null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_female_employees"
                      className="form-label mb-0"
                    >
                      No. of Female Employees:{' '}
                      {validateForm.renderMessage('no_of_female_employees')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_female_employees"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_female_employees')}
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_van') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="no_of_van" className="form-label mb-0">
                      No. of Van Delivery Vehicle: (0 if not applicable):{' '}
                      {validateForm.renderMessage('no_of_van')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_van"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_van')}
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_truck') !== null ? (
                  <div className="col-12 form-group">
                    <label htmlFor="no_of_truck" className="form-label mb-0">
                      No. of Truck Delivery Vehicle: (0 if not applicable):{' '}
                      {validateForm.renderMessage('no_of_truck')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_truck"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_truck')}
                    />
                  </div>
                ) : null}

                {_.get(businessChangeRequest, 'no_of_motorcycle') !== null ? (
                  <div className="col-12 form-group">
                    <label
                      htmlFor="no_of_motorcycle"
                      className="form-label mb-0"
                    >
                      No. of Motorcycle Delivery Vehicle: (0 if not applicable):{' '}
                      {validateForm.renderMessage('no_of_motorcycle')}
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="no_of_motorcycle"
                      onChange={onChange}
                      value={_.get(formData, 'no_of_motorcycle')}
                    />
                  </div>
                ) : null}

                {filteredBusinessNecessaryField.map((item) => {
                  const multiplier = _.get(item, 'multiplier', '');
                  const options = _.get(item, 'options');
                  return _.get(
                    businessChangeRequest,
                    `details.${multiplier}`
                  ) !== null ? (
                    <Fragment key={multiplier}>
                      {options ? (
                        <div className="col-12 form-group">
                          <label className="form-label mb-0">
                            {ucwords(multiplier ?? '').replace(/_/g, ' ')}{' '}
                            {businessNecessaryValidator.renderMessage(
                              multiplier
                            )}
                          </label>
                          <Select
                            name={multiplier}
                            options={selectOptions(options)}
                            value={
                              selectOptions(options).find((option) => {
                                return (
                                  _.get(formDataDetails, multiplier) ===
                                  _.get(option, 'value')
                                );
                              }) || ''
                            }
                            onChange={onChangeBusinessNecessaryField(
                              multiplier
                            )}
                            components={{ IndicatorSeparator: () => null }}
                          />
                        </div>
                      ) : (
                        <div className="col-12 form-group">
                          <label
                            htmlFor={multiplier}
                            className="form-label mb-0"
                          >
                            {ucwords(multiplier ?? '').replace(/_/g, ' ')}{' '}
                            {businessNecessaryValidator.renderMessage(
                              multiplier
                            )}
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            id={multiplier}
                            name={multiplier}
                            onChange={onChangeBusinessNecessaryField(
                              multiplier
                            )}
                            value={_.get(formDataDetails, `${multiplier}`)}
                          />
                        </div>
                      )}
                    </Fragment>
                  ) : (
                    <></>
                  );
                })}
                {!_.isEmpty(filteredQuantityMatrix) ? (
                  filteredQuantityMatrix.map((item) => {
                    const multiplier = _.get(item, 'multiplier', '');

                    return (
                      <React.Fragment>
                        <div className='form-group col-12 mb-0'>
                          <label className='form-label mb-0 text-capitalize'>
                            {multiplier}
                          </label>
                        </div>
                        <div className="w-100 border rounded-lg mx-3">
                          <table className="table table-borderless table-sm table-striped table-hover mb-0">
                            <thead>
                              <tr className="form-group">
                                <td className="col-4 form-label text-center border-right">Unit</td>
                                <td className="col-4 form-label text-center border-right">Capacity</td>
                                <td className="col-4 form-label text-center border-right">Number of Units</td>
                              </tr>
                            </thead>
                            <tbody>
                              {item.quantity_matrix.map((quantityMatrixItem) => {
                                const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                                return (
                                  // eslint-disable-next-line react/no-array-index-key
                                  <tr
                                    key={quantityMatrixMultiplier}
                                    className="border-top form-group"
                                  >
                                    <td className="col-4 text-left form-label border-right">
                                      {_.get(quantityMatrixItem, 'unit')}
                                    </td>
                                    <td className="col-4 text-left form-label border-right">
                                      {_.get(quantityMatrixItem, 'capacity')}
                                    </td>
                                    <td className="col-4 text-left form-label">
                                      <NumberFormat
                                        name={quantityMatrixMultiplier}
                                        id={quantityMatrixMultiplier}
                                        allowLeadingZeros
                                        className="form-control"
                                        onValueChange={(values) => {
                                          const { floatValue } = values;
                                          onChangeDetails(quantityMatrixMultiplier, floatValue);
                                        }}
                                        displayType="input"
                                        thousandSeparator
                                        isNumericString
                                        value={_.get(formData, `details.quantity_matrix.${quantityMatrixMultiplier}`)}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </React.Fragment>
                    )
                  })
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </Section>

        <Section title="Business Activities">
          <div className="row">
            <div className="col-12">
              <p className="font-weight-bold text-center">New Activities</p>
            </div>
            {isEmpty(_.get(businessChangeRequest, 'activities')) ? (
              <p
                className="col-12 text-muted font-italic text-center"
                style={{ fontSize: '.9em' }}
              >
                No new activity found.
              </p>
            ) : (
              <>
                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Current Information
                  </div>
                  <div className="row">
                    {!isEmpty(newActivitiesPrev) &&
                      newActivitiesPrev.map((activityPrev) => {
                        const details = _.get(activityPrev, 'details', {});
                        const businessLineId = _.get(
                          activityPrev,
                          'business_line_id',
                          0
                        );
                        const capitalAmount = _.get(
                          activityPrev,
                          'capital_amount',
                          ''
                        );

                        return (
                          <div className="col-12" key={businessLineId}>
                            <div className="row border p-2 m-2 rounded">
                              <div className="col-12 form-group">
                                <label
                                  htmlFor="business_line_name"
                                  className="form-label mb-0"
                                >
                                  Business Line
                                </label>

                                <BusinessLine
                                  customStyle={reactSelectCustomStyleCms()}
                                  value={businessLineId}
                                  name="business_line_id"
                                  onChange={() => {}}
                                  disabled
                                />
                              </div>

                              <div className="col-12 form-group">
                                <label
                                  htmlFor="business_line"
                                  className="form-label mb-0"
                                >
                                  Capital Amount
                                </label>

                                <input
                                  className="form-control"
                                  type="text"
                                  name="business_line"
                                  value={capitalAmount}
                                  disabled
                                />
                              </div>

                              <Activities
                                details={Array.isArray(details) ? {} : details}
                                businessLineId={businessLineId}
                                statusId={21}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Requested Changes
                  </div>
                  <div className="row">
                    {!isEmpty(formDataActivities) &&
                      formDataActivities.map((activity) => {
                        const details = _.get(activity, 'details', {});
                        const businessLineId = _.get(
                          activity,
                          'business_line_id',
                          0
                        );
                        const capitalAmount = _.get(
                          activity,
                          'capital_amount',
                          ''
                        );

                        const getValidation = (key) => {
                          const formDataActivity = formDataActivities.find(
                            (a) => +a?.business_line_id === +businessLineId
                          );
                          if (_.get(formDataActivity, key))
                            return (
                              <small
                                className="fa fa-check text-success"
                                style={{ fontSize: 10, padding: '1px' }}
                              />
                            );

                          return (
                            <small
                              className=" text-danger"
                              style={{ fontSize: 10, padding: '1px' }}
                            >
                              Required
                            </small>
                          );
                        };

                        return (
                          <div className="col-12" key={businessLineId}>
                            <div className="row border p-2 m-2 rounded">
                              <div className="col-12 form-group">
                                <label
                                  htmlFor="business_line_name"
                                  className="form-label mb-0"
                                >
                                  Business Line{' '}
                                  {getValidation('business_line_id')}
                                </label>

                                <BusinessLine
                                  customStyle={reactSelectCustomStyleCms()}
                                  value={businessLineId}
                                  name="business_line_id"
                                  onChange={() => {}}
                                  disabled
                                />
                              </div>

                              <div className="col-12 form-group">
                                <label
                                  htmlFor="capital_amount"
                                  className="form-label mb-0"
                                >
                                  Capital Amount{' '}
                                  {getValidation('capital_amount')}
                                </label>

                                <NumberFormat
                                  name="capital_amount"
                                  id="capital_amount"
                                  placeholder="0.00"
                                  className="form-control"
                                  onValueChange={(values) => {
                                    const { value } = values;
                                    onChangeActivities(
                                      businessLineId,
                                      'multiplier',
                                      'capital_amount',
                                      value
                                    );
                                  }}
                                  displayType="input"
                                  decimalScale={2}
                                  isNumericString
                                  allowNegative
                                  thousandSeparator
                                  allowLeadingZeros
                                  prefix="₱ "
                                  value={capitalAmount}
                                  isAllowed={(values) => {
                                    const { value } = values;
                                    if (!value) return true;
                                    const val = new Decimal(value);
                                    const max = new Decimal(MAX_LIMIT);
                                    return value === undefined || val.lte(max);
                                  }}
                                />
                              </div>

                              <Activities
                                details={Array.isArray(details) ? {} : details}
                                businessLineId={businessLineId}
                                isRequested
                                onChange={(multiplier, key, value) =>
                                  onChangeActivities(businessLineId, multiplier, key, value)
                                }
                                statusId={21}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <p className="font-weight-bold text-center">
                Existing Activities
              </p>
            </div>

            {isEmpty(_.get(businessChangeRequest, 'existing_activities')) ? (
              <p
                className="col-12 text-muted font-italic text-center"
                style={{ fontSize: '.9em' }}
              >
                No existing activity found.
              </p>
            ) : (
              <>
                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Current Information
                  </div>
                  <div className="row">
                    {!isEmpty(existingActivitiesPrev) &&
                      existingActivitiesPrev.map((activityPrev) => {
                        const details = _.get(activityPrev, 'details', {});
                        const businessLineId = _.get(
                          activityPrev,
                          'business_line_id',
                          0
                        );
                        const capitalAmount = _.get(
                          activityPrev,
                          'capital_amount',
                          ''
                        );
                        const hasChanges = (
                          formDataExistingActivities || []
                        ).find(
                          (formDataActivity) =>
                            +formDataActivity?.business_line_id ===
                            +businessLineId
                        );
                        if (hasChanges) {
                          return (
                            <div
                              className="col-12"
                              key={`existing-current-${businessLineId}`}
                            >
                              <div className="row border p-2 m-2 rounded">
                                <div className="col-12 form-group">
                                  <label
                                    htmlFor="business_line"
                                    className="form-label mb-0"
                                  >
                                    Business Line
                                  </label>

                                  <BusinessLine
                                    customStyle={reactSelectCustomStyleCms()}
                                    value={businessLineId}
                                    name="business_line_id"
                                    onChange={() => {}}
                                    disabled
                                  />
                                </div>

                                <div className="col-12 form-group">
                                  <label
                                    htmlFor="business_line"
                                    className="form-label mb-0"
                                  >
                                    Capital Amount
                                  </label>

                                  <input
                                    className="form-control"
                                    type="text"
                                    name="business_line"
                                    value={capitalAmount}
                                    disabled
                                  />
                                </div>

                                <Activities
                                  details={
                                    Array.isArray(details) ? {} : details
                                  }
                                  businessLineId={businessLineId}
                                />
                              </div>
                            </div>
                          );
                        }

                        return <></>;
                      })}
                  </div>
                </div>

                <div className="col-6">
                  <div className="row ml-auto text-primary font-weight-bold mb-2">
                    Requested Changes
                  </div>
                  <div className="row">
                    {!isEmpty(formDataExistingActivities) &&
                      formDataExistingActivities.map((activityRequest) => {
                        const details = _.get(activityRequest, 'details', {});
                        const businessLineId = _.get(
                          activityRequest,
                          'business_line_id',
                          0
                        );
                        const existingCapitalAmount = _.get(
                          activityRequest,
                          'capital_amount',
                          ''
                        );

                        const getValidation = (key) => {
                          const formDataActivity =
                            formDataExistingActivities.find(
                              (a) => +a?.business_line_id === +businessLineId
                            );
                          if (_.get(formDataActivity, key))
                            return (
                              <small
                                className="fa fa-check text-success"
                                style={{ fontSize: 10, padding: '1px' }}
                              />
                            );

                          return (
                            <small
                              className=" text-danger"
                              style={{ fontSize: 10, padding: '1px' }}
                            >
                              Required
                            </small>
                          );
                        };

                        return (
                          <div
                            className="col-12"
                            key={`existing-requested-${businessLineId}`}
                          >
                            <div className="row border p-2 m-2 rounded">
                              <div className="col-12 form-group">
                                <label
                                  htmlFor="business_line_id"
                                  className="form-label mb-0"
                                >
                                  Business Line{' '}
                                  {getValidation('business_line_id')}
                                </label>

                                <BusinessLine
                                  customStyle={reactSelectCustomStyleCms()}
                                  value={businessLineId}
                                  name="business_line_id"
                                  onChange={() => {}}
                                  disabled
                                />
                              </div>

                              <div className="col-12 form-group">
                                <label
                                  htmlFor="capital_amount"
                                  className="form-label mb-0"
                                >
                                  Capital Amount{' '}
                                  {getValidation('capital_amount')}
                                </label>

                                <NumberFormat
                                  name="capital_amount"
                                  id="capital_amount"
                                  placeholder="0.00"
                                  className="form-control"
                                  onValueChange={(values) => {
                                    const { value } = values;
                                    onChangeExistingActivities(
                                      businessLineId,
                                      'multiplier',
                                      'capital_amount',
                                      value
                                    );
                                  }}
                                  displayType="input"
                                  decimalScale={2}
                                  isNumericString
                                  allowNegative
                                  thousandSeparator
                                  allowLeadingZeros
                                  prefix="₱ "
                                  value={existingCapitalAmount}
                                  isAllowed={(values) => {
                                    const { value } = values;
                                    if (!value) return true;
                                    const val = new Decimal(value);
                                    const max = new Decimal(MAX_LIMIT);
                                    return value === undefined || val.lte(max);
                                  }}
                                />
                              </div>

                              <Activities
                                details={Array.isArray(details) ? {} : details}
                                businessLineId={businessLineId}
                                isRequested
                                onChange={(multiplier, key, value) =>
                                  onChangeExistingActivities(businessLineId, multiplier, key, value)
                                }
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>
        </Section>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Assess`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ChangeRequestModal.propTypes = {
  changeApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,

  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,

  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  // vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,

  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  businessNecessaryField:
    _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
  // vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeRequestModal);
